/*!
 * Copyright © 2018-2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { ESpeedType, ECountry, ESpeedLimitTypes } from '../../../core/models';

@Component({
  selector: 'fm-speed-violation',
  templateUrl: './speed-violation.component.html',
  styleUrls: ['./speed-violation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpeedViolationComponent {
  @Input()
  public country: string;
  @Input()
  public speed: number;
  @Input()
  public speedType: ESpeedType;
  @Input()
  public speedLimitType: ESpeedLimitTypes;

  public ESpeedType = ESpeedType;
  public ECountry = ECountry;
  public ESpeedLimitTypes = ESpeedLimitTypes;
}
